import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2, BarChart3, BookMarked, Target, Pill, MessageSquareHeart, ClipboardCheck, BoxIcon } from 'lucide-react';
interface Bonus {
  title: string;
  icon: BoxIcon;
  items: string[];
}
const bonuses: Bonus[] = [{
  title: 'Gráfico de Progreso Visual para el Paciente',
  icon: BarChart3,
  items: ['Dashboard visual con evolución de peso y medidas', 'Gráficos automáticos listos para mostrar en consulta', 'Aumenta la motivación y adherencia al tratamiento']
}, {
  title: 'Guía de Valores de Referencia Nutricional',
  icon: BookMarked,
  items: ['Tablas de IMC y clasificación por rango', 'Requerimientos calóricos por edad, sexo y objetivo', 'Distribución de macros según tipo de tratamiento']
}, {
  title: 'Plantilla de Objetivos y Metas',
  icon: Target,
  items: ['Definición de metas medibles desde la primera consulta', 'Registro de plazos, indicadores y compromisos del paciente', 'Revisión de objetivos en cada consulta de seguimiento']
}, {
  title: 'Registro de Suplementación',
  icon: Pill,
  items: ['Control de suplementos indicados con dosis y frecuencia', 'Seguimiento de fecha de inicio y respuesta del paciente', 'Registro de interacciones y observaciones clínicas']
}, {
  title: 'Encuesta de Satisfacción del Paciente',
  icon: MessageSquareHeart,
  items: ['Formulario profesional de cierre de tratamiento', 'Preguntas orientadas a obtener testimonios reales', 'Registro de puntos de mejora para tu consultorio']
}, {
  title: 'Checklist de Alta Nutricional',
  icon: ClipboardCheck,
  items: ['Criterios objetivos de cierre de tratamiento', 'Registro de logros alcanzados y recomendaciones finales', 'Documento firmado por el paciente al momento del alta']
}];
export function Bonuses() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);
  return <section className="py-20 bg-amber-50/40" data-id="element-18">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <span className="inline-block bg-amber-100 text-amber-700 font-bold text-sm uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-21">
            🎁 Bonos de regalo
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-22">
            6 Bonos Estratégicos Incluidos
          </h2>
          <p className="text-amber-700 font-semibold mt-3" data-id="element-23">
            Todos sin costo adicional al adquirir tu kit
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-24">
          {bonuses.map((bonus, index) => {
          const isExpanded = expandedIndex === index;
          const Icon = bonus.icon;
          return <div key={index} className={`bg-white rounded-xl border overflow-hidden transition-all duration-300 ${isExpanded ? 'border-amber-400 shadow-md ring-1 ring-amber-300/40' : 'border-amber-200/60 hover:border-amber-300'}`} data-id="element-25">
                <button onClick={() => setExpandedIndex(isExpanded ? null : index)} className={`w-full px-5 py-4 flex items-center justify-between text-left focus:outline-none transition-colors ${isExpanded ? 'bg-amber-50' : 'bg-white hover:bg-amber-50/50'}`} data-id="element-26">
                  <div className="flex items-center gap-4 min-w-0" data-id="element-27">
                    <div className="relative flex-shrink-0" data-id="element-28">
                      <div className={`w-14 h-14 rounded-2xl flex items-center justify-center transition-colors ${isExpanded ? 'bg-amber-500 text-white shadow-md shadow-amber-500/30' : 'bg-amber-100 text-amber-600'}`} data-id="element-29">
                        <Icon size={26} strokeWidth={2} data-id="element-30" />
                      </div>
                      <span className={`absolute -top-2 -right-2 w-6 h-6 rounded-full flex items-center justify-center text-xs font-extrabold border-2 border-white shadow-sm ${isExpanded ? 'bg-amber-600 text-white' : 'bg-amber-500 text-white'}`} data-id="element-31">
                        {index + 1}
                      </span>
                    </div>
                    <div className="min-w-0" data-id="element-32">
                      <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-33">
                        <span className="text-xs font-bold uppercase tracking-wider text-amber-600" data-id="element-34">
                          Bono {index + 1}
                        </span>
                        <span className="inline-flex items-center bg-nutri-cta text-white text-[10px] font-extrabold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-35">
                          Gratis
                        </span>
                      </div>
                      <span className={`block font-bold text-base md:text-lg leading-tight ${isExpanded ? 'text-amber-900' : 'text-gray-800'}`} data-id="element-36">
                        {bonus.title}
                      </span>
                    </div>
                  </div>
                  <ChevronDown className={`transition-transform duration-300 flex-shrink-0 ml-2 ${isExpanded ? 'rotate-180 text-amber-500' : 'text-gray-400'}`} size={24} data-id="element-37" />
                </button>

                <AnimatePresence data-id="element-38">
                  {isExpanded && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-39">
                      <div className="px-5 pb-6 pt-4 border-t border-amber-200/60 bg-white" data-id="element-40">
                        <ul className="space-y-3 pl-[4.5rem]" data-id="element-41">
                          {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-42">
                              <CheckCircle2 className="text-amber-500 flex-shrink-0 mt-0.5" size={18} data-id="element-43" />
                              <span data-id="element-44">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="bg-nutri-dark text-white rounded-xl p-6 text-center shadow-lg max-w-2xl mx-auto" data-id="element-45">
          <p className="text-xl font-bold" data-id="element-46">
            Los <span className="text-amber-400" data-id="element-47">6 bonos</span> están{' '}
            <span className="text-nutri-cta" data-id="element-48">
              incluidos sin costo adicional
            </span>{' '}
            con tu NutriPro Kit
          </p>
        </div>
      </div>
    </section>;
}